import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../AbstractElements";
import { Apps, SupportTicket, SupportTicketList } from "../../Constant";
import CommonCardHeader from "../../Common/CommonCardHeader";
import { SUPPORT_DATA } from "../../Data/SupportTicket";
import TicketList from "./TicketList";
import TicketTable from "./TicketTable";

const SupportTicketContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={SupportTicket} parent={Apps} title={SupportTicket} />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CommonCardHeader title={SupportTicketList} span={SUPPORT_DATA} />
              <CardBody>
                <TicketList/>
                <TicketTable/>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default SupportTicketContainer;
